/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { accept } from '../fn/contracts/accept';
import { Accept$Params } from '../fn/contracts/accept';


/**
 * Contract acceptance endpoints. Requires authentication.
 */
@Injectable({ providedIn: 'root' })
export class ContractsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `accept()` */
  static readonly AcceptPath = '/merchants/{merchantId}/contract';

  /**
   * Accepts the contract of specified merchant.
   *
   * The caller merchant accepts the contract of merchant specified by `merchantId` in the URL. Requires authentication.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accept()` instead.
   *
   * This method doesn't expect any request body.
   */
  accept$Response(params: Accept$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = accept(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Accepts the contract of specified merchant.
   *
   * The caller merchant accepts the contract of merchant specified by `merchantId` in the URL. Requires authentication.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accept$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accept(params: Accept$Params, context?: HttpContext): Observable<void> {
    const resp = this.accept$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
